import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import AlumniListGrid from './AlumniListGrid';
import Layout from './Layout';
import { getinstituteList } from '../../../library/Service/domainService';
import useManagementDashboard from '../../management/dashboard/useManagementDashboard';
import ManageAlumniService from '../../management/alumni-list/ManageAlumniService';

const ManageAlumni = () => {
    const navigate = useNavigate();
    const { globalState } = useContext(GlobalContext);
    const { getCampuses } = useManagementDashboard();

    const campuses = getCampuses();
    console.log('campuses', campuses);
    const [instituteList, setinstituteList] = useState(getinstituteList('MANAGEMENT_INSTITUTE_DOMAIN', campuses));

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const updateFormConfigForInternalAdmin = (formConfig: any, pageName?: string) => {
        //return formConfig;
        // Update the formConfig dynamically here
        const updatedFormConfig = JSON.parse(JSON.stringify(formConfig));

        // Find the control you want to update
        let searchCriteriaSection = updatedFormConfig.sectionRepository.find((section: any) => section.id === 'searchCriteria');

        if (searchCriteriaSection) {
            let instituteIdControl = searchCriteriaSection.controlGroup.find((control: any) => control.id === 'instituteId');

            if (instituteIdControl) {
                // Change the domainCategoryCode to a new value
                //instituteIdControl.props.domainCategoryCode = 'INSTITUTE_DOMAIN'; // Replace with your new domainCategoryCode
                instituteIdControl.type = 'SELECT_V2'; // Replace with your new domainCategoryCode
                instituteIdControl.id = 'instituteId';
            }

            let programIdControl = searchCriteriaSection.controlGroup.find((control: any) => control.id === 'programId');

            if (programIdControl) {
                // Change the domainCategoryCode to a new value
                programIdControl.props.domainCategoryCode = 'ALL_PROGRAM_CODE'; // Replace with your new domainCategoryCode
                programIdControl.props.parentId = 'instituteId';
                programIdControl.type = 'MULTI_SELECT_CUSTOM_CONTROL_2';
                //programIdControl.type = 'SELECT_V2'; // Replace with your new domainCategoryCode
            }

            if (pageName === 'track-alumni-profiles' && !searchCriteriaSection.controlGroup.some((c: any) => c.id === 'membershipFeePaymentStatusCode')) {
                const filterControl = {
                    id: 'membershipFeePaymentStatusCode',
                    type: 'MULTI_SELECT_CUSTOM_CONTROL_2',
                    props: {
                        label: 'Membership Fees Payment Status',
                        customProperties: {},
                        domainCategoryCode: 'MEMBERSHIP_FEE_PAYMENT_STATUS_CODE',
                    },
                    className: 'col-md-3',
                };
                const meterIds = ['almaMaterPride', 'marketability', 'vibrancy', 'donorScore', 'mentorshipScore', 'recruiterScore'];
                const insertAt = searchCriteriaSection.controlGroup.findIndex((c: any) => meterIds.includes(c.id));
                if (insertAt >= 0) {
                    searchCriteriaSection.controlGroup.splice(insertAt, 0, filterControl);
                } else {
                    searchCriteriaSection.controlGroup.push(filterControl);
                }
            }
        }
        return updatedFormConfig;
    };
    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;

    const updatedformCondif = updateFormConfigForInternalAdmin(formConfig, routeInfo?.pageName);

    useEffect(() => {
        const domain = new Map([...globalState.domain]);
        // domain.set('INSTITUTE_PROGRAM_CODE', internal?.programDomainData ?? []);

        const userStatusCodes = domain.get('USER_STATUS_CODE');
        if (userStatusCodes) {
            const filtereduserstatusCode = userStatusCodes.filter((status) => status.code !== 'PENDING_EMAIL_VERIFICATION');
            domain.set('USER_STATUS_CODE', filtereduserstatusCode);
        }

        const scoreCodes = domain.get('SOCIAL_MEDIA_LEVEL');
        if (scoreCodes) {
        const filteredScoreCodes = scoreCodes
            .filter((status) => status.code !== 'Not Engaged')
            .map((status) =>
            status.code === 'Medium'
                ? { ...status, code: 'Moderate', value: 'Moderate' }
                : status
            );

        domain.set('SOCIAL_MEDIA_LEVEL', filteredScoreCodes);
        }

        const yesNoNA = domain.get('YES_NO_NA_CODE');
        if (yesNoNA) {
        const filteryesNoNACodes = yesNoNA
            .map((status) =>
            status.code === 'NA'
                ? { ...status, code: 'Not Available', value: 'Not Available' }
                : status
            );

        domain.set('YES_NO_NA_CODE', filteryesNoNACodes);
        }

        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig: updatedformCondif, 
                 data: { 
                    ...data, 
                    isSingleCampus: instituteList?.length === 1,
                    searchCriteria: {
                        ...data?.searchCriteria,
                        instituteId:  instituteList?.length === 1 ? [instituteList[0]?.code] : data?.searchCriteria?.instituteId
                    }
                },  
                domain, internal, routeInfo },
        });

        dispatch({
            type: 'SET_DOMAIN',
            payload: { key: 'MANAGEMENT_INSTITUTE_DOMAIN', value: instituteList },
        });
    }, []);

    // When the loader deferred the alumni search (isListLoading), fetch the list in the
    // background so the page renders instantly. Uses the same criteria the loader would
    // have used, so the result is identical to the original blocking fetch.
    useEffect(() => {
        if (!(data as any)?.isListLoading) return;
        let isActive = true;
        const pageName = (routeInfo as any)?.pageName;
        ManageAlumniService.search(ManageAlumniService.getDefaultSearchCriteria(pageName), pageName)
            .then((response: any) => {
                if (!isActive) return;
                dispatch({ type: 'UPDATE_CONTROL_VALUE', payload: { dataKey: 'alumniList', value: response?.data ?? [] } });
                dispatch({ type: 'UPDATE_CONTROL_VALUE', payload: { dataKey: 'isListLoading', value: false } });
            })
            .catch((error: any) => {
                console.error('Error loading alumni list:', error);
                if (isActive) dispatch({ type: 'UPDATE_CONTROL_VALUE', payload: { dataKey: 'isListLoading', value: false } });
            });
        return () => {
            isActive = false;
        };
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && (
                <Layout>
                    {/* Please check layout for the <SearchCriteria /> */}
                    <AlumniListGrid />
                </Layout>
            )}
        </SmartContext.Provider>
    );
};

export default ManageAlumni;
